// extracted by mini-css-extract-plugin
export default {"wrapper":"Switch_wrapper__4zFoF","label":"Switch_label__JG4sj","switch":"Switch_switch__n+oYF","slider":"Switch_slider__CmgZ0","round":"Switch_round__ajZpd"};